import { Pressable, Text, View } from 'react-native'

export function SessionScreenMessageState({
  actionLabel,
  message,
  onPress,
}: {
  actionLabel: string
  message: string
  onPress: () => void
}) {
  return (
    <View className="flex-1 justify-center items-center bg-background-primary">
      <Text className="text-base text-destructive mb-2.5">{message}</Text>
      <Pressable onPress={onPress}>
        <Text className="text-base text-primary">{actionLabel}</Text>
      </Pressable>
    </View>
  )
}
